@if (client.isPrerender) {
  <div
    class="visually-hidden">
    @for (filter of listing?.getFiltersWithMatches(); track filter) {
      @if (filter.filterType === 'attribute-option') {
        <div>
          @for (option of options(filter); track option) {
            <div>
              <href [link]="option | facetUrl : asFilterAttributeOption(filter)">{{option.label}}</href>
            </div>
          }
        </div>
      }
    }
  </div>
}
